import { Controller } from 'stimulus';

export default class extends Controller {
  editSection(event: Event) {
    event.preventDefault();
    const section = this.sectionFromEvent(event);
    if (!section) return;

    section.querySelectorAll('.edit-field').forEach((el: HTMLElement) => {
      el.style.display = 'block';
    });
    section.querySelectorAll('.display-value').forEach((el: HTMLElement) => {
      el.style.display = 'none';
    });

    const editBtn = section.querySelector('.edit-section') as HTMLElement | null;
    const saveBtn = section.querySelector('.save-section') as HTMLElement | null;
    const cancelBtn = section.querySelector('.cancel-section') as HTMLElement | null;

    if (editBtn) editBtn.style.display = 'none';
    if (saveBtn) saveBtn.style.display = 'inline-block';
    if (cancelBtn) cancelBtn.style.display = 'flex';
  }

  cancelEdit(event: Event) {
    event.preventDefault();
    const section = this.sectionFromEvent(event);
    if (!section) return;

    section.querySelectorAll('.edit-field').forEach((el: HTMLElement) => {
      el.style.display = 'none';
    });
    section.querySelectorAll('.display-value').forEach((el: HTMLElement) => {
      el.style.display = 'inline';
    });

    const editBtn = section.querySelector('.edit-section') as HTMLElement | null;
    const saveBtn = section.querySelector('.save-section') as HTMLElement | null;
    const cancelBtn = section.querySelector('.cancel-section') as HTMLElement | null;

    if (saveBtn) saveBtn.style.display = 'none';
    if (cancelBtn) cancelBtn.style.display = 'none';
    if (editBtn) editBtn.style.display = 'inline-block';
  }

  saveSection(event: Event) {
    event.preventDefault();
    const section = this.sectionFromEvent(event);
    if (!section) return;

    const itemId = section.dataset.itemId;
    if (!itemId) return;

    const formData = new FormData();
    section.querySelectorAll('.edit-field input').forEach((input: HTMLInputElement) => {
      formData.append(input.name, input.value);
    });

    fetch(`/items/${itemId}/update_use_expectancy`, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': this.getCsrfToken(),
        Accept: 'application/json'
      },
      body: formData
    })
      .then((resp) => {
        if (resp.ok) {
          window.location.reload();
        } else {
          alert('Error saving Use Expectancy');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Error saving Use Expectancy');
      });
  }

  private sectionFromEvent(event: Event): HTMLElement | null {
    const el = event.currentTarget as HTMLElement;
    return (el.closest("[data-controller='items--use-expectancy-field']") as HTMLElement) || null;
  }

  private getCsrfToken(): string {
    const token = document.querySelector("meta[name='csrf-token']") as HTMLMetaElement;
    return token ? token.getAttribute('content') || '' : '';
  }
}
